/**
 * App枚举常量
 *
 * @export
 * @enum {number}
 */
// eslint-disable-next-line no-shadow
export enum AppEnum {
	/** MATERIAL URL */
	UMATERIAL_BASE_URL = '/umaterial',

	/** UBUY URL */
	UBUY_BASE_URL = '/ubuy',

	/** DEV URL */
	DEV_BASE_URL = '/dev-api',

	/** DEV URL */
	CASE_V3 = '/api',

	/** CAS COMMON-DATA */
	CAS_COMMON_DATA_URL = '/api',

	// =========================== BFC 微服务群 ==========================

	/** 需求微服务 */
	BFC_REQUIRE_URL = '/require',

	/** 订单微服务 */
	BFC_ORDER_URL = '/order',

	/** 验收微服务 /order*/
	BFC_ACCEPTANCE_URL = '/acceptance',

	/** 账单微服务 /order*/
	BFC_BILL_URL = '/bill',

	/** 物料（商品库）微服务 */
	BFC_MATERIAL_URL = '/material',

	/** 决策微服务 */
	BFC_DECISION_URL = '/decision',

	/** 价格微服务 /order*/
	BFC_PRICE_URL = '/price',

	/** 基础数据微服务 */
	BFC_COMMON_DATA_URL = '/common-data',

	/** 供应商微服务 */
	BFC_SUPPLIER_URL = '/supplier'
}
